import e from "../node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/template.js";
import "./uuid.js";
import { defineComponent as t, isRef as n } from "vue";
//#region src/lib/utils.ts
var r = () => "", i = t({
	name: "SmartRenderer",
	props: { children: null },
	render({ children: e }) {
		return n(e) ? e.value : e;
	}
});
function a(e) {
	return typeof e == "number" || /^-?\d+(?:\.\d+)?$/.test(e) ? `${e}px` : e;
}
function o(e, t = "modelValue") {
	if (!e) return !1;
	let n = Object.keys(e);
	return n.includes(t) && n.includes(`onUpdate:${t}`);
}
function s(e) {
	return typeof e == "function" ? e() : e;
}
function c(t) {
	return e(t, { interpolate: /\{{2}([\s\S]+?)\}{2}/g });
}
//#endregion
export { i as SmartRenderer, r as cc, s as resolveVNode, a as styleNumberValueWithUnit, c as template, o as vnodeBindingVModel };

//# sourceMappingURL=utils.js.map